// Handles the "Give Up" action by updating the cart attribute
function handleGiveUp() {
  const data = {
    attributes: {
      'Gift': 'Give Up'
    }
  };

  fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data)
  })
    .then(response => response.json())
    .then(data => {
      console.log('Cart updated:', data);
    })
    .catch(error => {
      console.error('Error updating cart:', error);
    });
}

// Binds click events to the target buttons
function bindCartBotButtonEvents() {
  const closeButton = document.querySelector('.cartbot-confirmation-close-button');
  const denyButton = document.querySelector('.cartbot-confirmation-deny-button');

  if (closeButton) {
    closeButton.addEventListener('click', handleGiveUp);
  }

  if (denyButton) {
    denyButton.addEventListener('click', handleGiveUp);
  }
}

// Initial binding
bindCartBotButtonEvents();

// Support for dynamically loaded buttons (e.g., via AJAX)
const observer = new MutationObserver(bindCartBotButtonEvents);
observer.observe(document.body, {
  childList: true,
  subtree: true
});